package app

import app.properties.*
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onKeyDownFunction
import kotlinx.html.onKeyDown
import react.*
import react.dom.*

interface CompanyState : RState {
    var company: Company?
}
class CompanyForm(props: CompanyInterface) : RComponent<CompanyInterface, CompanyState>(props) {
    init {
        state.company = props.company
    }
    private val companyTypeList = props.companyType

    override fun componentDidMount() {
        val datepicker = js("""jQuery('#createDateDatepicker').datepicker({
                            format: 'dd/mm/yyyy',
                            autoclose: true,
                        });""")

        datepicker.on("change", fun() {
            setState {
                company?.createDate = datepicker.datepicker("getFormattedDate")
            }
        })

        val companyDirectorBirthday = js("""jQuery('#companyDirectorBirthday').datepicker({
                            format: 'dd/mm/yyyy',
                            minViewMode: "2",
                            endDate: "-18y",
                            autoclose: true
                        });""")

        companyDirectorBirthday.on("change", fun() {
            setState {
                company?.birthDay = companyDirectorBirthday.datepicker("getFormattedDate")
            }
        })
    }

    override fun componentDidUpdate(prevProps: CompanyInterface, prevState: CompanyState, snapshot: Any) {
        val companyDirectorBirthday = js("""jQuery('#companyDirectorBirthday').datepicker({
                            format: 'dd/mm/yyyy',
                            minViewMode: "2",
                            endDate: "-18y",
                            autoclose: true
                        });""")

        companyDirectorBirthday.on("change", fun() {
            setState {
                company?.birthDay = companyDirectorBirthday.datepicker("getFormattedDate")
            }
        })
    }

    override fun RBuilder.render() {
        div("row") {
            div("col-lg-4 col-md-12") {
                label { +"Կազմակերպության տեսակը" }
                select("form-control") {
                    attrs {
                        if(props.company?.companyType == null && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.name = "companyType"
                    attrs["value"] = companyTypeList?.indexOfFirst { it.id == props.company?.companyType?.id }.toString()
                    attrs.onChangeFunction = {
                        val index = getTargetValueToInt(it)
                        val companyType = if (index == null)  null  else companyTypeList?.get(index)
                        setState {
                            company?.companyType = companyType
                        }
                    }
                    option { +"Ընտրել կազմակերպության տեսակը" }
                    companyTypeList?.forEachIndexed { index, companyType ->
                        option {
                            attrs.value = index.toString()
                            +companyType.name
                        }
                    }
                }
            }
            if(state.company?.companyType?.id == companyTypeList?.get(1)?.id) {
                div("col-lg-4 col-md-12") {
                    label { +"Ծննդյան տարեթիվ /օր, ամիս, տարի/" }
                    input(classes = "form-control") {
                        attrs {
                            if(props.company?.birthDay == "" && props.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }
                        attrs["value"] = props.company?.birthDay ?: ""
                        attrs.id = "companyDirectorBirthday"
                    }
                }
            }
        }
        div("row") {
            div("col-lg col-md-12") {
                label { +"Կազմակերպության անվանումը" }
                input(classes = "form-control") {
                    attrs {
                        if(props.company?.name == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.value = props.company?.name ?: ""
                    attrs.onChangeFunction = {
                        val name = getTargetValue(it)
                        setState {
                            company?.name = name
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"ՀՎՀՀ" }
                input(classes = "form-control") {
                    attrs {
                        val r = Regex("^([0-9]{6})+$")
                        if(!r.containsMatchIn(props.company?.hhvh ?: "") && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.value = props.company?.hhvh ?: ""
                    attrs.onChangeFunction = {
                        val hhvh = getTargetValue(it)
                        setState {
                            company?.hhvh = hhvh
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"Գործունեության հասցե" }
                input(classes = "form-control") {
                    attrs {
                        if(props.company?.address == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.value = props.company?.address ?: ""
                    attrs.onChangeFunction = {
                        val address = getTargetValue(it)
                        setState {
                            company?.address = address
                        }
                    }
                }
            }
        }
        div("row") {
            div("col-lg col-md-12") {
                label { +"Փորձը ոլորտում" }
                input(classes = "form-control", type = InputType.number) {
                    attrs {
                        if( props.company?.workingTime ?: 0 <= 0 && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.max = "50"
                    attrs.value = if ((props.company?.workingTime ?: 0) > 0) props.company?.workingTime.toString() else ""
                    attrs.onChangeFunction = {
                        val workingTime = getTargetValueToInt(it) ?: 0
                        setState {
                            company?.workingTime = if (workingTime > 50) 50 else workingTime
                        }
                    }
                }
            }



            div("col-lg col-md-12") {
                label { +"Գրանցման ամսաթիվը" }
                input(classes = "form-control") {
                    attrs {
                        if(props.company?.createDate == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.id = "createDateDatepicker"
                    attrs.value = props.company?.createDate ?: ""
                    attrs.onChangeFunction = {
                        val createDate = getTargetValue(it)
                        setState {
                            company?.createDate = createDate
                        }
                    }
                }
            }

            div("col-lg col-md-12") {
                label { +"Աշխատակիցների քանակը" }
                input(classes = "form-control", type = InputType.number) {
                    attrs {
                        if((props.company?.staffCount ?: 0) <= 0 && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.value = if ((props.company?.staffCount ?: 0) > 0) props.company?.staffCount.toString() else ""
                    attrs.onChangeFunction = {
                        val staffCount = getTargetValueToInt(it)
                        setState {
                            company?.staffCount = staffCount
                        }
                    }
                }
            }
        }
        div("row") {
            div("col-lg col-md-12") {
                label { +"Տնօրենի Ա․Ա․Հ․" }
                input(classes = "form-control") {
                    attrs {
                        if(props.company?.companyDirector?.firstname == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                        placeholder = "Անուն"
                    }
                    attrs.value = props.company?.companyDirector?.firstname ?: ""
                    attrs.onChangeFunction = {
                        val directorFirstName = getTargetValue(it)
                        setState {
                            company?.companyDirector?.firstname = directorFirstName
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"" }
                input(classes = "form-control") {
                    attrs {
                        if(props.company?.companyDirector?.lastname == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                        placeholder = "Ազգանուն"
                    }
                    attrs.value = props.company?.companyDirector?.lastname ?: ""
                    attrs.onChangeFunction = {
                        val directorLastName = getTargetValue(it)
                        setState {
                            company?.companyDirector?.lastname = directorLastName
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"" }
                input(classes = "form-control") {
                    attrs {
                        if(props.company?.companyDirector?.parentName == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                        placeholder = "Հայրանուն"
                    }
                    attrs.value = props.company?.companyDirector?.parentName ?: ""
                    attrs.onChangeFunction = {
                        val directorParentName = getTargetValue(it)
                        setState {
                            company?.companyDirector?.parentName = directorParentName
                        }
                    }
                }
            }
        }
    }
}

interface CompanyInterface : RProps {
    var company: Company?
    var companyType: Array<CompanyType>?
    var touch: Boolean
}

fun RBuilder.companyForm(company: Company?, companyType: Array<CompanyType>?, touch: Boolean) = child(CompanyForm::class) {
    attrs.company = company
    attrs.companyType = companyType
    attrs.touch = touch
}